import { Component } from '@angular/core';
import { ICellRendererParams } from '@ag-grid-community/core';
import { CapGainsEstimatesListing } from '@products/types/tax.type';
import { NotificationTypes } from '@accounts/accounts-alerts/accounts-alerts.interface';

@Component({
  selector: 'ft-fund-name-cell-renderer',
  templateUrl: './fund-name-cell-renderer.component.html',
  styleUrls: ['./fund-name-cell-renderer.component.scss'],
})
export class FundNameCellRendererComponent {
  fundName: string;
  fundLink: string;
  actualsAlert: boolean;
  notificationType = NotificationTypes.ALERT; // We've condition to show only one type i.e., 'alert' for 'actuals'.

  agInit(params: ICellRendererParams) {
    const record: CapGainsEstimatesListing = params.data;

    this.fundName = record.fundName;
    this.fundLink = record.fundLink;
    this.actualsAlert = record.actualsAlert;
  }
}
